import { Box } from "@mui/material";
import React from "react";
import welcome from "../images_new/welcome.svg";
import welcomeMob from "../images_new/welcomeMob.svg";

function Welcome() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: { md: "flex", xs: "none" },
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <img
          src={welcome}
          alt="Welcome"
          style={{ maxWidth: "100%", maxHeight: "70%", objectFit: "cover" }}
        />
      </Box>
      <Box
        sx={{
          display: { md: "none", xs: "flex" },
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <img
          src={welcomeMob}
          alt="Welcome"
          style={{ maxWidth: "100%", maxHeight: "70%", objectFit: "cover" }}
        />
      </Box>
    </Box>
  );
}

export default Welcome;
